import client from "@/services/shopify";
import Logger from "../helpers/logger";

class CheckoutDataService {
  constructor(checkoutId) {
		this.checkoutId = checkoutId;
	}
  setCheckoutId(checkoutId){
              this.checkoutId = checkoutId;
  }
  getCheckoutId(){
              return this.checkoutId;
  }

  // Creates a new cart (Shopify checkout)
  async createCart(){
    // Create an empty checkout
    let checkout = await client.checkout.create()
    this.setCheckoutId(checkout.id);
    Logger.log("FIRST CREATE OF CHECKOUT");
    Logger.log(this.checkoutId);
    Logger.log(checkout.webUrl);
    return {id: checkout.id, webUrl: checkout.webUrl};
  }

  // Loads the cart given a Shopify checkout id
  async loadCart(id){
    this.setCheckoutId(id);
    let checkout = await client.checkout.fetch(id);
    Logger.log("LOADED CART");
    Logger.log(checkout);

    const checkoutData = (null === checkout.completedAt) ? {id: checkout.id, webUrl: checkout.webUrl, discounts: checkout.discountApplications} : {id: '', webUrl: '', discounts: [{code: '', value: {amount: 0, percentage: 0}}]};
    return checkoutData;
  }

  // Gets product details (author & format) for a product
  async getProductById(productId){
    let product = await client.product.fetch(productId);
    // Do something with the product
    Logger.log("GET PRODUCT");
    Logger.log(product);
    return product;
  }

  // Gets author and format information for each product in cart
  async getAllProductsForCart(lineItems){
    return await Promise.all(lineItems.map(async item => ({...item, product: await this.getProductById(item.variant.product.id)})));
  }

  // Gets all line items in cart
  async getCart(){
    let checkout = await client.checkout.fetch(this.getCheckoutId());
    // Do something with the checkout
    let lineItems = await this.getAllProductsForCart(checkout.lineItems);
    Logger.log("GOT CART");
    Logger.log(lineItems);
    return lineItems;
  }

  // Adds a product to the cart
  async addItemToCart(variantId, quantity){
    const lineItemsToAdd = [
      {
        variantId: variantId,
        quantity: quantity,
        //customAttributes: [{key: "MyKey", value: "MyValue"}]
      }
    ];
    try {
      let checkout = await client.checkout.addLineItems(this.getCheckoutId(), lineItemsToAdd);
      let lineItems = await this.getAllProductsForCart(checkout.lineItems);
      Logger.log("ADD ITEMS LOG STARTED");
      Logger.log(lineItemsToAdd);
      Logger.log(checkout);
      Logger.log(lineItems);
      Logger.log("ADD ITEMS LOG ENDED");
      return lineItems;
    } catch (error) {
      Logger.log(error);
      localStorage.removeItem('HBGCartStore');
      await this.createCart();
      let checkout = await client.checkout.addLineItems(this.getCheckoutId(), lineItemsToAdd);
      let lineItems = await this.getAllProductsForCart(checkout.lineItems);
      Logger.log("ADD ITEMS LOG STARTED");
      Logger.log(lineItemsToAdd);
      Logger.log(checkout);
      Logger.log(lineItems);
      Logger.log("ADD ITEMS LOG ENDED");
      return lineItems;     
    }
  }
  
  // Removes a product from the cart
  async removeItemFromCart(variantId){
    const lineItemIdsToRemove = [
      variantId
    ];
    
    // Remove an item from the checkout
    let checkout = await client.checkout.removeLineItems(this.getCheckoutId(), lineItemIdsToRemove);
    let lineItems = await this.getAllProductsForCart(checkout.lineItems);
    Logger.log("REMOVED ITEM");
    Logger.log(lineItems);
    return lineItems;
  }
  
  // Updates quantity of a product in the cart
  async updateItemInCart(variantId, quantity){
    const lineItemsToUpdate = [
      {
        id: variantId, 
        quantity: quantity
      }
    ];
    
    // Update the line item on the checkout (change the quantity or variant)
    let checkout = await client.checkout.updateLineItems(this.getCheckoutId(), lineItemsToUpdate);
    let lineItems = await this.getAllProductsForCart(checkout.lineItems);
    Logger.log("UPDATED CHECKOUT");
    Logger.log(lineItems);
    return lineItems;
  }

  // Adds a discount to the cart
  async addDiscount(discount){
    // Add a discount code to the checkout
    let checkout = await client.checkout.addDiscount(this.getCheckoutId(), discount);
    Logger.log("ADDED DISCOUNT");
    Logger.log(checkout);
    if (checkout.userErrors.length > 0){
      Logger.log("ADD DISCOUNT ERROR");
      Logger.log(checkout.userErrors);
      return false;
    }
    return checkout.discountApplications;
  }

  // Removes a discount from the cart
  async removeDiscount(){
    let checkout = await client.checkout.removeDiscount(this.getCheckoutId());
    Logger.log("REMOVED DISCOUNT");
    Logger.log(checkout);
    return checkout.lineItems;
  }

  // Sets the referring URL to send to Shopify
  async setReferrer(referrer){
    let checkout = await client.checkout.updateAttributes(this.getCheckoutId(), {customAttributes: [{key: 'referrer', value: referrer}]});
    Logger.log("SET REFERRER");
    Logger.log(checkout);
  }
}

export default new CheckoutDataService();
